module.exports = __webpack_public_path__ + "static/media/Nguyen-Duc-Dat.432571d7.jpg";